import { SupportRecommendedArticles } from "./SupportRecommendedArticles";
import { useSupport } from "../../SupportContext";

export function SupportRecommendedArticlesContainer() {
  const { articles, categories } = useSupport();

  if (articles.length === 0) {
    return null;
  }

  return <SupportRecommendedArticles categories={categories} />;
}

export default SupportRecommendedArticlesContainer;
